import { render, staticRenderFns } from "./SliderWith3btn.vue?vue&type=template&id=bae72c24&scoped=true"
import script from "./SliderWith3btn.vue?vue&type=script&lang=js"
export * from "./SliderWith3btn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bae72c24",
  null
  
)

export default component.exports